import { v4 as uuidv4 } from 'uuid';
import { Editor } from 'grapesjs';
import { GjsActionTypes, GjsAttributeNames, GjsComponentTypes, GjsMetaTypes } from "./Enums";
import { embeddedImagesBase64 } from '../../../interfaces/VisageUI';
import { CustomEventTypes } from '../../../globals';

const onMousedownFunction = `
(function() {
	//event.preventDefault();
	event.stopPropagation();
	event.bubbles = false;
	window.parent.postMessage({
		type: "${CustomEventTypes.gjsComponentClicked}", 
		detail: {
			id: event.currentTarget.getAttribute('id'),
			button: event.button,
			mousePosition: { x: event.clientX, y: event.clientY },
		},
	});
}).call(event)
`;

const onClickFunction = `
(function() {
	//event.preventDefault();
	event.stopPropagation();
	event.bubbles = false;
}).call(event)
`;

const onTextDoubleClickFunction = `
(function() {
	//event.preventDefault();
	event.stopPropagation();
	//console.log("i was double clicked:", event.currentTarget);
	window.parent.postMessage({
		type: "${CustomEventTypes.gjsComponentClicked}", 
		detail: {
			id: event.currentTarget.getAttribute('id'),
		},
	});
	window.parent.postMessage({
		type: "${CustomEventTypes.gjsContentEditStart}", 
		detail: {
			id: event.currentTarget.getAttribute('id'),
		},
	});
	event.currentTarget.setAttribute('contenteditable', 'true'); // start editing
	event.currentTarget.setAttribute('draggable', 'false'); // disable dragging when editing
	event.currentTarget.focus();
}).call(event)
`;

const onTextBlurFunction = `
(function() {
	event.preventDefault();
	event.stopPropagation();
	//console.log("i was blurred:", event.currentTarget, event.currentTarget.innerHTML);
	event.currentTarget.setAttribute('contenteditable', 'false'); // disable editing
	event.currentTarget.setAttribute('draggable', 'true'); // re-enable dragging
	window.parent.postMessage({
		type: "${CustomEventTypes.gjsContentEditEnd}", 
		detail: {
			id: event.currentTarget.getAttribute('id'),
			newContent: event.currentTarget.innerHTML,
		},
	});
}).call(event)
`;

const onPasteFunction = `
(function() {
	event.preventDefault();
    const text = event.clipboardData
        ? (event.originalEvent || event).clipboardData.getData('text/plain')
        : // For IE
        window.clipboardData
        ? window.clipboardData.getData('Text')
        : '';

	if (document.queryCommandSupported('insertText')) {
		document.execCommand('insertText', false, text);
	} else {
		// Insert text at the current position of caret
		const range = document.getSelection().getRangeAt(0);
		range.deleteContents();

		const textNode = document.createTextNode(text);
		range.insertNode(textNode);
		range.selectNodeContents(textNode);
		range.collapse(false);

		const selection = window.getSelection();
		selection.removeAllRanges();
		selection.addRange(range);
	}
}).call(event)
`;

const onTextKeyDownFunction = `
(function() {
	//event.preventDefault();
	event.stopPropagation();
	//console.log("key down:", event);
	// numEnter should end; esc should end; ctrl+enter should end
	if (event.key === "Enter" && (event.ctrlKey || event.location === 3) || event.key === "Escape")
	{
		event.currentTarget.blur();
	}
}).call(event)
`;

export function loadComponents(editor: Editor)
{
	editor.DomComponents.addType(GjsComponentTypes.Image, {
		model: {
			defaults: {
				resizable: {
					tl: 0, // Top left
					tc: 0, // Top center
					tr: 0, // Top right
					cl: 0, // Center left
					cr: 0, // Center right
					bl: 0, // Bottom left
					bc: 0, // Bottom center
					br: 0 // Bottom right
				},
				attributes: {
					id: "C" + uuidv4(),
					"asset-id": "",
					src: embeddedImagesBase64.imagePlaceholder,
					onmousedown: onMousedownFunction,
					onclick: onClickFunction,
				},
			},
		},
	});

	editor.DomComponents.addType(GjsComponentTypes.Div, {
		model: {
			defaults: {
				attributes: {
					id: "C" + uuidv4(),
					onmousedown: onMousedownFunction,
					onclick: onClickFunction,
				},
			},
		},
	});

	editor.DomComponents.addType(GjsComponentTypes.Text, {
		model: {
			defaults: {
				tagName: 'div', // actually a div in disguise?
				attributes: {
					id: "C" + uuidv4(),					
					onmousedown: onMousedownFunction,
					//onclick: onClickFunction,
					ondblclick: onTextDoubleClickFunction,
					onblur: onTextBlurFunction,
					onkeydown: onTextKeyDownFunction,
					onpaste: onPasteFunction, 
				},
			},
		},
	});

	editor.DomComponents.addType(GjsComponentTypes.TextNode, {
		model: {
			defaults: {
				attributes: {
					id: "C" + uuidv4(),
					onmousedown: onMousedownFunction,
					onclick: onClickFunction,
				},
			},
		},
	});

	editor.DomComponents.addType(GjsComponentTypes.Video, {
		model: {
			defaults: {
				tagName: 'div', // actually a div placeholder
				attributes: {
					id: "C" + uuidv4(),
					[GjsAttributeNames.Action]: GjsActionTypes.PlayVideo,
					[GjsAttributeNames.MetaType]: GjsMetaTypes.Video,
					onmousedown: onMousedownFunction,
					onclick: onClickFunction,
				},
			}
		}
	});

	editor.DomComponents.addType(GjsComponentTypes.Audio, {
		model: {
			defaults: {
				tagName: 'div', // actually a div placeholder
				attributes: {
					id: "C" + uuidv4(),
					[GjsAttributeNames.Action]: GjsActionTypes.PlayAudio,
					[GjsAttributeNames.MetaType]: GjsMetaTypes.Audio,
					onmousedown: onMousedownFunction,
					onclick: onClickFunction,
				},
			}
		}
	});

	editor.DomComponents.addType(GjsComponentTypes.Camera, {
		model: {
			defaults: {
				tagName: 'canvas',
				attributes: {
					id: "C" + uuidv4(),
					[GjsAttributeNames.Action]: GjsActionTypes.EnlargeCamera,
					[GjsAttributeNames.MetaType]: GjsMetaTypes.Camera,
					width: 1472,
					height: 828,
					onmousedown: onMousedownFunction,
					onclick: onClickFunction,
				},
			}
		},
	});
}